import { SatisfactionQuestionType } from 'root/src/shared/survey/survey.types';
export const SATISFACTION_QUESTIONS = {
    RECOMMEND_STRENGTH: {
        questionType: SatisfactionQuestionType.SINGLE_CHOICE,
        question: 'How likely are you to recommend Dare Drop to a friend?',
        options: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
    },
    RECOMMEND_REASON: {
        questionType: SatisfactionQuestionType.OPEN,
        question: 'What\'s your main reason for this rating?',
    },
    ISSUES: {
        questionType: SatisfactionQuestionType.MULTI_CHOICE,
        question: 'Did you encounter any of these issues while using Dare Drop?',
        options: [
            'Didn\'t see any games I wanted to stream',
            'Didn\'t know what to do',
            'Didn\'t know how to introduce to my stream',
            'Didn\'t know how to join a drop',
            'Didn\'t know how this will improve engagement with my audience',
            'Didn\'t get verification email',
        ],
    },
    DROP_RELEVANCE: {
        questionType: SatisfactionQuestionType.SINGLE_CHOICE,
        question: 'The drops I saw were:',
        options: [
            'Always relevant',
            'Often relevant',
            'Sometimes relevant',
            'Rarely relevant',
            'Never relevant',
            'What are drops?',
        ],
    },
    DISCOVERY_METHOD: {
        questionType: SatisfactionQuestionType.SINGLE_CHOICE,
        question: 'How did you hear about Dare Drop?',
        options: [
            'Dare Drop emailed me',
            'Another person\'s stream',
            'A friend (word of mouth)',
            'Social Media',
            'Search Engine (Google, Bing, Yahoo, etc)',
        ],
    },
};
